import {
	Component, Input, Output, EventEmitter, ChangeDetectorRef
} from '@angular/core';
import { UserDto } from 'UvExplorerServer.Dtos.TS';
import { PrepareNetworkTransferResultDto, NetworkAgentInfo, NetViewDto } from 'UvExplorerServer.Dtos.TS/NetViews';

@Component({
	selector: 'prepare-network-transfer-dialog',
	templateUrl: './prepare-network-transfer-dialog.component.html',
	styleUrls: ['./prepare-network-transfer-dialog.component.scss'],
})
export class PrepareNetworkTransferDialogComponent {

	@Input()
	public visible: boolean;

	@Input()
	public transferScope: NetViewDto;

	@Input()
	public transferTargetUser: UserDto;

	@Input()
	public transferInfo: PrepareNetworkTransferResultDto;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public onOk: EventEmitter<NetworkAgentInfo[]>;

	@Output()
	public onCancel: EventEmitter<any>;

	public selectedNetworkAgents: any;

	constructor(private changeDetector: ChangeDetectorRef) {
		this.visible = false;
		this.transferScope = null;
		this.transferTargetUser = null;
		this.transferInfo = null;
		this.visibleChange = new EventEmitter<boolean>();
		this.onOk = new EventEmitter<any>();
		this.onCancel = new EventEmitter<any>();
		this.selectedNetworkAgents = undefined;
	}

	public get networkName(): string {
		return (!!this.transferScope ? this.transferScope.Name : "");
	}

	public get targetUsername(): string {
		return (!!this.transferTargetUser ? this.transferTargetUser.Username : "");
	}

	public get networkAgents(): NetworkAgentInfo[] {
		return (!!this.transferInfo ? this.transferInfo.NetworkAgents.ToArray() : []);
	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);
		this.changeDetector.markForCheck();
	}

	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);
		this.changeDetector.markForCheck();
	}

	public onDialogHide(): void {
		this.onCancelClicked();
	}

	public onOkClicked(): void {

		let result: NetworkAgentInfo[] = [];
		if (!!this.selectedNetworkAgents) {
			if (Array.isArray(this.selectedNetworkAgents)) {
				result = [...this.selectedNetworkAgents];
			}
			else {
				result = [this.selectedNetworkAgents];
			}
		}

		this.hide();
		this.onOk.emit(result);
	}

	public onCancelClicked(): void {
		this.hide();
		this.onCancel.emit();
	}
}
